import { IUserFacingMessages } from '../Interfaces'

const UserFacingMessagesLV: IUserFacingMessages = {
  'ok': `Pieprasījums izdevās!`,
  'request-fail': `Notikusi sistēmas kļūda`,
  'server-fail': `Neizdevās sazināties ar serveri`,
}

export default UserFacingMessagesLV
